import { CoralogixRum, type CoralogixBrowserSdkConfig } from "@coralogix/browser";

import { currentEnv, isProduction } from "@shared/utils/fullscriptEnv/fullscriptEnv";

/**
 * Coralogix initialization for the client
 */
const clientInitCoralogix = (configOverrides: Partial<CoralogixBrowserSdkConfig> = {}) => {
  if (isProduction()) {
    CoralogixRum.init({
      application: "hw-admin",
      ...configOverrides,
      public_key: "cxtp_EqgIywKtCY3hfp6bhwlek1bjFN0w5s",
      version: process.env.CI_COMMIT_SHA || "local",
      coralogixDomain: "US1",
      environment: currentEnv(),
    });
  }
};

export { clientInitCoralogix };
